import { useEffect, useCallback } from "react";

// 30 minuti in ms
const useIdleTimeout = (onIdle, timeout = 1800000) => {
   const handleLogout = useCallback(() => {
      onIdle();
   }, [onIdle]);

   useEffect(() => {
      // Se timeout è null, non attivare il timer
      if (!timeout) {
         return;
      }

      let timer;

      const resetTimer = () => {
         if (timer) clearTimeout(timer);
         timer = setTimeout(handleLogout, timeout);
      };

      // Eventi da monitorare
      const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];

      // Inizializza il timer e aggiungi i listener
      resetTimer();
      events.forEach((event) => window.addEventListener(event, resetTimer));

      // Cleanup alla distruzione del componente
      return () => {
         if (timer) clearTimeout(timer);
         events.forEach((event) => window.removeEventListener(event, resetTimer));
      };
   }, [handleLogout, timeout]);
};

export default useIdleTimeout;
